import {
  Component,
  ElementRef,
  EventEmitter, Input,
  OnDestroy,
  OnInit, Output,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
  AfterViewInit,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ToastService} from "../../../services/Toast.service";
import {StateService} from "../../../services/StateService";
import {SwitchBoard} from "../../../services/SwitchBoard";
import {Router} from "@angular/router";
import {LoadingService} from "../../../services/LoadingService";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {TaxPlanningService} from "../../../tpiq-services/tax-planning.service";
import {PageTitleService} from "../../../services/PageTitle";
import {takeUntil} from "rxjs/operators";
import {Session} from "../../../services/Session";
import {TpiqSelectDropdownComponent} from "../../../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";
import {TpiqInputSearchComponent} from "../../../input-search/tpiq-input-search/tpiq-input-search.component";
import {FormatAmountPipe} from "../../../pipes/format-amount.pipe";
import {v4 as uuid} from 'uuid';
import {ModelBasedNumeral} from "../../../directives/model-numeral";
import {TpiqCustomDatepicker} from "../../../directives/tpiq-custom-datepicker";
import * as bootstrap from 'bootstrap';
import {FeatureFlagService} from "../../../tpiq-services/feature-flag.service";
import { evaluate } from 'mathjs';
import { rememberInvestmentAmount, updateInvestmentOverride } from '../../../utils-lib/investment-override';

declare const _: any;

@Component({
  selector: 'app-review-tax-strategies',
  standalone: true,
  imports: [CommonModule, FormsModule, TpiqSelectDropdownComponent, TpiqInputSearchComponent, FormatAmountPipe, ModelBasedNumeral,
  TpiqCustomDatepicker],
  templateUrl: './review-tax-strategies.component.html',
  styleUrl: './review-tax-strategies.component.scss',
})
export class ReviewTaxStrategiesComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {

 ngAfterViewInit() {
    setTimeout(() =>this.initTooltips(),2000);
  }

  private initTooltips() {
      const tooltipTriggerList = Array.from(
        document.querySelectorAll('[data-bs-toggle="tooltip"]')
      );
      tooltipTriggerList.forEach((el: any) => {
        const existingTooltip = bootstrap.Tooltip.getInstance(el);
        if (existingTooltip) {
          existingTooltip.dispose();
        }
        new bootstrap.Tooltip(el);
      });
    }

  org: string = Session.getOrg();
  user: any = {};
  @Input() allTaxStrategies: any;
  @Input() strategies: any;
  @Input() reviewedStrategiesData: any;
  @Input() client: any;
  @Input() plan: any;
  @Input() states: any;
  @Input() isRapMaximized: boolean = false;
  @Input() isRapEditMode: boolean = false;
  @Output() onStrategyRiviewedSuccess: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCreateTaskAction: EventEmitter<any> = new EventEmitter<any>();
  @Output() onStrategyRemoved: EventEmitter<any> = new EventEmitter<any>();
  destroy$: EventEmitter<void> = new EventEmitter<void>();

  clientsList: Array<any> = [];
  filteredStrategies: Array<any> = [];
  newStrategy: any = {};
  years: Array<any> = [];
  allAssociatedData: any = {};
  associatedWith: Array<any> = [
    {id: 'a627ccde-dd57-1090-cefa-fc965526a557', name: 'Effective Rate'},
    {id: '82c36191-8d6f-39e7-f711-947591551608', name: 'Marginal Rate'},
    {id: '5a314bc1-4534-0426-1db4-d18403485072', name: 'Cap Gain Rate'},
    {id: '23a5e1b2-03cf-6675-2596-0952387d4b46', name: 'C Corp Flat Rate'},
    {id: 'f637945b-e78e-11ef-a4a7-0e0adc17208f', name: 'Market Growth Rate'},
    {id: '393a6f91-8222-11ef-bd9d-12ff30f54e53', name: 'Full Credit'},
    {id: 'ce08f4de-b7f2-449c-9bf8-9674fbf6d0d5', name: 'Qualified Dividends'},
    {id: '454ba189-8222-11ef-bd9d-12ff30f54e53', name: 'N/A'}
  ];
  defaultStrategyId = '';
  defaultStateAssociatedId = '';
  allStateAssociatedData: Array<any> = [];
  showAddCustomRateInPopup: boolean;
  newCustomRate: any = {
    id: '',
    name: '',
    rate: 0,
    formula: {
      displayValue: '',
      actualValue: '',
      displayValuesArray: [],
      actualValuesArray: []
    }
  };
  currentSelectedStrategy: any;
  showField = true;
  reviewAndAddToPlan = false;
  isInvestmentFeature: boolean ;
  @ViewChild('reviewStrategiesInfo', { static: true }) reviewStrategiesInfo!: TemplateRef<any>;
  @ViewChild('scrollContainer') private scrollContainer!: ElementRef;

  constructor(
    private _router: Router,
    private titleService: PageTitleService,
    private loadingService: LoadingService,
    private stateService: StateService,
    private toastService: ToastService,
    private switchBoard: SwitchBoard,
    private taxPlanningService: TaxPlanningService,
    private viewContainerRef: ViewContainerRef,
    private featureFlagService: FeatureFlagService
  ) {}

  /** Count of reviewed entries that map to a currently-selected strategy. Guards against
   *  orphan / null-strategyId entries inflating the count (e.g. "8 out of 7") - ticket 868kjbfbb. */
  get reviewedCount(): number {
    if (!this.reviewedStrategiesData || !this.strategies) { return 0; }
    const ids = new Set(this.strategies.map((s: any) => s.id));
    // Count DISTINCT matching strategy ids so duplicate persisted entries can't inflate
    // the count (e.g. still showing "8 out of 7") - ticket 868kjbfbb.
    return new Set(
      this.reviewedStrategiesData
        .filter((r: any) => r && r.strategyId && ids.has(r.strategyId))
        .map((r: any) => r.strategyId)
    ).size;
  }

  ngOnInit(): void {
    this.viewContainerRef.createEmbeddedView(this.reviewStrategiesInfo);
    this.isInvestmentFeature = this.featureFlagService.isEnabled('enableInvestmentFeature');
    this.titleService.setPageTitle('');
    this.user = Session.getUser();
    this.strategies = _.orderBy(this.strategies, 'planAmount', 'desc');
    this.strategies.forEach(s => this.normalizeStrategyFields(s));
    this.strategies.forEach(s => {
      const reviewed = _.find(this.reviewedStrategiesData, { strategyId: s.id });
      s.reviewed = reviewed? true : false;
    });
    _.each(this.strategies, (strategy) => {
      if (strategy.suggestedInfo) {
        strategy.suggestedInfo = strategy.suggestedInfo.split("$$state$$").join(this.getStateName());
        strategy.suggestedInfo = strategy.suggestedInfo.split("0 state").join(this.getStateName());
      }
    });

    this.fillYears();
    this.parseCustomRates();
    this.appendCustomRates();
    // this.buildStateAssociatedObject();
    if (this.client && this.client.relatedParties) {
      this.clientsList = this.client.relatedParties || [];
    }
  
    if (this.strategies && this.strategies.length > 0) {
      _.each(this.strategies, (strategy) => {
        strategy.showFullDescription = false;
      });

        this.strategies.forEach((strategy) => {
        this.selectStrategy(strategy);
      });
    }
    this.switchBoard.onClickPrev.pipe(takeUntil(this.destroy$)).subscribe(obj => {
      const prevState = this.stateService.getPrevState();
      if (prevState) {
        this.stateService.pop();
        this._router.navigate([prevState.url]);
      }
    });
  }

   ngOnChanges(changes: SimpleChanges): void {
    if (changes.plan?.currentValue) {
      this.buildStateAssociatedObject();
      // When plan updates after strategies are already displayed (e.g. initializeRapEditSession
      // fires after goToSelectedSection), re-evaluate the current strategy's state rate now
      // that allStateAssociatedData has the real entries.
      // Toggle showField so the dropdown is destroyed+recreated with the updated allStateAssociatedData,
      // forcing setDefaultValue to run getValue against the now-populated data array.
      if (!changes['strategies'] && this.currentSelectedStrategy) {
        this.showField = false;
        this.setStrategy(this.currentSelectedStrategy);
        setTimeout(() => { this.showField = true; });
      }
    }
    if (changes['strategies']) {
      this.handleStrategiesUpdate(changes['strategies'].currentValue);
    }
  }

  private handleStrategiesUpdate(data: any) {
    this.strategies = _.orderBy(data, 'planAmount', 'desc');
    this.strategies.forEach(s => this.normalizeStrategyFields(s));
    this.strategies.forEach(s => {
      const reviewed = _.find(this.reviewedStrategiesData, { strategyId: s.id });
      s.reviewed = reviewed? true : false;
    });
    _.each(this.strategies, (strategy) => {
      if (strategy.suggestedInfo) {
        strategy.suggestedInfo = strategy.suggestedInfo.split("$$state$$").join(this.getStateName());
        strategy.suggestedInfo = strategy.suggestedInfo.split("0 state").join(this.getStateName());
      }
    });

    if (this.strategies && this.strategies.length > 0) {
      _.each(this.strategies, (strategy) => {
        strategy.showFullDescription = false;
      });

        this.strategies.forEach((strategy) => {
        this.selectStrategy(strategy);
      });
    }
  }

  getStateName() {
    let stateObj = _.find(this.states, {short: this.plan.homeState});
    return stateObj ? stateObj.name : '';
  }

  setStrategy(strategy) {

    if (!this.allStateAssociatedData?.length || this.allStateAssociatedData.length === 1) {
      this.buildStateAssociatedObject();
    }
    
    this.newStrategy.strategyId = strategy.id;
    // carry over existing notes/report text if present on strategy or previously reviewed
    if (!this.newStrategy.notes && strategy.notes) {
      this.newStrategy.notes = strategy.notes;
    }
    if (!this.newStrategy.reportCustomText && strategy.reportCustomText) {
      this.newStrategy.reportCustomText = strategy.reportCustomText;
    }
    this.newStrategy.investmentDescription = this.buildInvestmentDescription(strategy);
    /** Investment feature logic */
    
     if (strategy.investment && strategy.investment.length > 0) {
        const inv = strategy.investment[0];

        this.newStrategy.investmentEnabled = inv.is_investment_enabled;
        this.newStrategy.investmentFormula = inv.investment_formula;

        if (
          inv.is_investment_enabled &&
          (!strategy.reviwedData ||
            strategy.reviwedData.investedAmount == 0)
        ) {
          this.newStrategy.investedAmount = strategy.planAmount
            ? Math.round(Number(strategy.planAmount) / Number(inv.investment_formula))
            : 0;
        }

      } else if (
        strategy.isInvestmentEnabled &&
        strategy.investmentFormula
      ) {
        this.newStrategy.investmentEnabled = strategy.isInvestmentEnabled;
        this.newStrategy.investmentFormula = strategy.investmentFormula;

        if (
          strategy.isInvestmentEnabled &&
          (!strategy.reviwedData ||
            strategy.reviwedData.investedAmount == 0)
        ) {
          this.newStrategy.investedAmount = strategy.planAmount
            ? Math.round(Number(strategy.planAmount) /
              Number(strategy.investmentFormula))
            : 0;
        }
      }
    
   
    this.newStrategy.locked = strategy.locked;

    if(!this.newStrategy.clientId) {
      let obj = _.find(this.clientsList, {default: true});
      if (obj) {
        this.newStrategy.clientId = obj.id;
        this.newStrategy.relatedPartyName = obj.name || '';
        this.newStrategy.parentClientId = this.client.id || '';
      }
    }

    if (!this.newStrategy.sinceYear) {
      // set Start Year to plan year by default
      if (this.plan.taxYear) {
        if (_.isString(this.plan.taxYear)) {
          this.newStrategy.sinceYear = _.toNumber(this.plan.taxYear);
        } else {
          this.newStrategy.sinceYear = this.plan.taxYear;
        }
      } else {
        this.newStrategy.sinceYear = '';
      }
    }

    if (strategy.aiSuggested) {
      // set plan amount
      this.newStrategy.amount = this.newStrategy.amount || strategy.planAmount;

      if (!this.newStrategy.associatedWith) {
        // set up associated value
        if (strategy.associatedWithName) {
          let obj = _.find(this.associatedWith, {name: this.getAssociatedWithName(strategy.associatedWithName)});
          if (obj) {
            this.newStrategy.associatedWith = obj.id;
            this.defaultStrategyId = obj.id;
          } else {
            // Defaulting to 'Full Credit'
            this.newStrategy.associatedWith = '454ba189-8222-11ef-bd9d-12ff30f54e53';
            this.defaultStrategyId = '454ba189-8222-11ef-bd9d-12ff30f54e53';
          }
        }
      } else {
        this.defaultStrategyId = this.newStrategy.associatedWith;
      }

      if (!this.newStrategy.stateAssociatedWith) {
        // set up state associated value
        if (strategy.stateAssociatedWithName) {
          let obj = this.getStateAssociated(strategy.stateAssociatedWithName);
          if (obj) {
            this.newStrategy.stateAssociatedWith = obj.id;
            this.defaultStateAssociatedId = obj.id;
          } else {
            this.newStrategy.stateAssociatedWith = '454ba189-8222-11ef-bd9d-12ff30f54e53';
            this.defaultStateAssociatedId = '454ba189-8222-11ef-bd9d-12ff30f54e53';
          }
        }
      } else {
        this.defaultStateAssociatedId = this.newStrategy.stateAssociatedWith;
      }
    } else {
      if (!this.newStrategy.associatedWith) {
        if (strategy.associatedWith) {
          this.newStrategy.associatedWith = strategy.associatedWith;
          this.defaultStrategyId = strategy.associatedWith;
        } else if (strategy.federal_associated_rate) {
          let obj = _.find(this.associatedWith, {name: this.getAssociatedWithName(strategy.federal_associated_rate)});
          if (obj) {
            this.newStrategy.associatedWith = obj.id;
            this.defaultStrategyId = obj.id;
          } else {
            this.newStrategy.associatedWith = '454ba189-8222-11ef-bd9d-12ff30f54e53';
            this.defaultStrategyId = '454ba189-8222-11ef-bd9d-12ff30f54e53';
          }
        } else {
          this.newStrategy.associatedWith = '';
          this.defaultStrategyId = '';
        }
      } else {
        this.defaultStrategyId = this.newStrategy.associatedWith;
      }
      // RAP edit: prefill State Associated Rate from source plan
      if (this.isRapEditMode) {
        if (this.newStrategy.stateAssociatedWith) {
          this.defaultStateAssociatedId = this.newStrategy.stateAssociatedWith;
        } else if (strategy.stateAssociatedWith) {
          this.newStrategy.stateAssociatedWith = strategy.stateAssociatedWith;
          this.defaultStateAssociatedId = strategy.stateAssociatedWith;
        } else {
          this.defaultStateAssociatedId = '';
        }
      }
      const nAId = '454ba189-8222-11ef-bd9d-12ff30f54e53';
      const isNAFallback = this.newStrategy.stateAssociatedWith === nAId &&
        strategy.state_associated_rate && strategy.state_associated_rate !== '--None--';
      if (!this.newStrategy.stateAssociatedWith || isNAFallback) {
        if (strategy.state_associated_rate) {
          const obj = this.getStateAssociated(strategy.state_associated_rate);
          if (obj) {
            this.newStrategy.stateAssociatedWith = obj.id;
            this.defaultStateAssociatedId = obj.id;
          } else {
            this.newStrategy.stateAssociatedWith = nAId;
            this.defaultStateAssociatedId = nAId;
          }
        } else {
          this.newStrategy.stateAssociatedWith = nAId;
          this.defaultStateAssociatedId = nAId;
        }
      } else {
        this.defaultStateAssociatedId = this.newStrategy.stateAssociatedWith;
      }
    }

    this.newStrategy.recurring = this.newStrategy.recurring || strategy.recurring;
    this.calculateResultAmount(this.newStrategy);
    this.calculateStateResultAmount(this.newStrategy);

    rememberInvestmentAmount(this.newStrategy, Number(this.newStrategy.investedAmount || 0));
    strategy['reviwedData'] = this.newStrategy;
  }

  getAssociatedWithName(associate) {
    let associatedWithName = associate;
    switch (associate) {
      case 'Effective Rate':
      case 'Marginal Rate':
      case 'Cap Gain Rate':
      case 'C Corp Flat Rate':
      case 'Market Growth Rate':
      case 'Qualified Dividends':
        associatedWithName = associate;
        break;
      case 'Capital Gain Rate':
        associatedWithName = 'Cap Gain Rate';
        break;
    }
    return associatedWithName;
  }

  getStateAssociated(stateAssociate) {
    let stateAssociated: any;
    _.each(this.allStateAssociatedData, (obj) => {
      if ((stateAssociate === 'State Individual Rate' || stateAssociate === 'Individual State Rate') && obj.name.includes('Ind State Rate')) {
        stateAssociated = obj;
      } else if ((stateAssociate === 'State Corporate Rate' || stateAssociate === 'Corporate State Rate') && obj.name.includes('Corp State Rate')) {
        stateAssociated = obj.name;
      }
    });
    return stateAssociated;
  }

  ngOnDestroy(): void {
    this.viewContainerRef.clear();
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  selectStrategy(strategy) {
    if (this.currentSelectedStrategy === strategy) return;
    this.showField = false;
    this.currentSelectedStrategy = strategy;
    _.each(this.strategies, (obj) => {
      if(obj.name === strategy.name) {
        obj.selected = true;
      } else {
        obj.selected = false;
      }
    });
    if (strategy && strategy.reviewed) {
      if(strategy.selected && !strategy.reviewed) {
        this.reviewedStrategiesData = [];
      }
      this.reviewAndAddToPlan = true;
      const obj = _.find(this.reviewedStrategiesData, {strategyId: strategy.id});
      if (obj) {
        this.newStrategy = obj;
      }
      
      this.defaultStrategyId = this.newStrategy.associatedWith;

      strategy['reviwedData'] = this.newStrategy;
      this.setStrategy(this.currentSelectedStrategy);
      _.each(this.strategies, (strategy) => {
            if(strategy.selected) {
              strategy.reviewed = true;
            }
          });

    } else {
      this.reviewAndAddToPlan = false;
      this.newStrategy = strategy.reviwedData || {};
      this.defaultStrategyId = '';
      this.defaultStateAssociatedId = '';
      this.setStrategy(this.currentSelectedStrategy);
    }
    setTimeout(() => {
      this.showField = true;
    });
  }

  setClient($event){
    this.newStrategy.clientId = $event.id;
    this.newStrategy.relatedPartyName = $event.name || '';
    this.newStrategy.parentClientId = this.client.id || '';
  }

  selectYear($event, key){
    if ($event && _.isString($event.entry.id)) {
      this.newStrategy[key] = _.toNumber($event.entry.id);
    } else {
      this.newStrategy[key] = $event.entry.id;
    }
  }

  calculateResultAmount(strategy, isStateRateCalcReq?){
    const associatedWithId = strategy.associatedWith;
    if (associatedWithId){
      const multiplierRate = this.getRate(strategy, associatedWithId);
      if (strategy.actualAmount) {
        strategy.roiAmount = multiplierRate * strategy.actualAmount;
      } else {
        strategy.roiAmount = multiplierRate * strategy.amount;
      }
      strategy.overriden = false;
    } else {
      strategy.roiAmount = (strategy.actualAmount) ? strategy.actualAmount : strategy.amount;
    }
    if (isStateRateCalcReq) {
      this.calculateStateResultAmount(strategy);
    }

  }

  getRate(strategy, associatedWithId){
    let rates = this.allAssociatedData[strategy.strategyId] || [];
    if (rates.length == 0){
      rates = this.associatedWith;
    }
    const obj = _.find(rates, {id: associatedWithId});
    if (obj){
      if (obj.name == 'Effective Rate'){
        return this.plan.effectiveRate / 100;
      } else if (obj.name == 'Marginal Rate'){
        return this.plan.marginalRate / 100;
      } else if (obj.name == 'Cap Gain Rate'){
        return this.plan.capGainRate / 100;
      } else if (obj.name == 'C Corp Flat Rate'){
        return this.plan.ccropFlatRate / 100;
      } else if (obj.name == 'Market Growth Rate'){
        return (this.plan.marketGrowthRate || 5) / 100;
      } else if (obj.name == 'Full Credit'){
        // Here Full Credit means 100% credit i.e 100/100
        return 1;
      }else if (obj.name == 'Qualified Dividends'){
        return (this.plan.marginalRate - this.plan.capGainRate) / 100;
      } else if (obj.name == 'N/A'){
        return 0;
      } else if (obj.formula && obj.formula.actualValuesArray && obj.formula.actualValuesArray.length > 0) {
        const fromula = (_.isString(obj.formula)) ? JSON.parse(obj.formula) : obj.formula;
        let calcVal = '';
        if (fromula.displayValuesArray && fromula.displayValuesArray.length > 0) {
          _.each(fromula.displayValuesArray, (value) => {
            if (value == 'Effective Rate') {
              calcVal += this.plan.effectiveRate;
            } else if (value == 'Marginal Rate'){
              calcVal += this.plan.marginalRate;
            } else if (value == 'Cap Gain Rate'){
              calcVal += this.plan.capGainRate;
            } else if (value == 'C Corp Flat Rate'){
              calcVal += this.plan.ccropFlatRate;
            } else if (value == 'Market Growth Rate'){
              calcVal += this.plan.marketGrowthRate || 5;
            }else if (obj.name == 'Qualified Dividends'){
              calcVal += this.plan.marginalRate - this.plan.capGainRate;
            } else {
              calcVal += value;
            }
          });
        }
        const result = calcVal ? evaluate(calcVal) : 0;
        return result ? (result / 100) : 1;      
      }  else {
        return obj.rate / 100;
      }
    } else {
      return 0;
    }
  }

  calculateStateResultAmount(strategy){
    const stateAssociatedWithId = strategy.stateAssociatedWith;
    if (stateAssociatedWithId){
      const multiplierRate = this.getStateRate(strategy, stateAssociatedWithId);
      strategy.stateRoiAmount = multiplierRate * ((strategy.actualAmount) ? strategy.actualAmount : strategy.amount);
      strategy.stateOrverriden = false;
    } else {
      strategy.stateRoiAmount = 0;
    }
  }

  getStateRate(strategy, stateAssociatedWithId){
    if (this.allStateAssociatedData && this.allStateAssociatedData.length > 0) {
      const obj = _.find(this.allStateAssociatedData, {id: stateAssociatedWithId});
      if (obj) {
        let stateRate: any;
        if (obj.name === 'Full Credit') {
          // Here Full Credit means 100% credit i.e 100/100
          stateRate = 1;
        } else if (obj.name === 'N/A') {
          stateRate = 0;
        } else {
          stateRate = obj.rate / 100;
        }
        return stateRate;
      }
    }
    return 0;
  }

  getTaxSavedTooltip(strategy: any, type: 'federal' | 'state'): string {
    if (!strategy) {
      return 'Est. Plan Amount * Selected Rate (0%)';
    }

    if (type === 'federal') {
      const rates = this.allAssociatedData[strategy.strategyId] || this.associatedWith || [];
      const selectedRate = _.find(rates, { id: strategy.associatedWith });
      const selectedRateName = selectedRate?.name || 'Selected Federal Rate';
      const percentage = this.getFormattedPercentage((this.getRate(strategy, strategy.associatedWith) || 0) * 100);
      return `Est. Plan Amount * ${selectedRateName} (${percentage}%)`;
    }

    const selectedStateRate = _.find(this.allStateAssociatedData || [], { id: strategy.stateAssociatedWith });
    const selectedStateRateName = selectedStateRate?.name || 'Selected State Rate';
    const statePercentage = this.getFormattedPercentage((this.getStateRate(strategy, strategy.stateAssociatedWith) || 0) * 100);
    return `Est. Plan Amount * ${selectedStateRateName} (${statePercentage}%)`;
  }

  private getFormattedPercentage(value: number): string {
    if (!_.isFinite(value)) {
      return '0';
    }

    const rounded = _.round(value, 2);
    return Number.isInteger(rounded) ? `${rounded}` : `${rounded}`;
  }

  setAssociatedWith($event, type){
    if (type == 'federal') {
      this.newStrategy.associatedWith = $event.id;
      this.calculateResultAmount(this.newStrategy);
    } else if (type == 'state') {
      this.newStrategy.stateAssociatedWith = $event.id;
      this.calculateStateResultAmount(this.newStrategy);
    }
  }

  toggleAddCustomRate(flag){
    this.showAddCustomRateInPopup = flag;
    if (this.showAddCustomRateInPopup) {
      setTimeout(() => {
        this.scrollToBottom();
      }, 100);
    }
  }

  openFormulaCalculator(tempCustomRate?, index?) {
  }

  appendNewCustomRate() {
    if (this.newCustomRate.name && this.newCustomRate.rate){
      this.newCustomRate.id = uuid();
      this.newCustomRate.formula =  JSON.stringify(this.newCustomRate.formula);
      this.loadingService.triggerLoadingEvent(true);
      this.taxPlanningService.addEditCustomRate(Session.getOrg(), this.user.id, this.plan.id, this.newCustomRate).subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.newCustomRate.formula =  JSON.parse(this.newCustomRate.formula);
        this.toastService.pop(TOAST_TYPE.success, 'Custom Rate created successfully');
        this.plan.customTaxRates.push(this.newCustomRate);
        this.associatedWith = [...this.associatedWith, this.newCustomRate];
        this.newStrategy.associatedWith = this.newCustomRate.id;
        this.newCustomRate = {
          id: '',
          name: '',
          formula: {
            displayValue: '',
            actualValue: '',
            displayValuesArray: [],
            actualValuesArray: []
          }
        };
        this.showAddCustomRateInPopup = false;
        this.buildAssociatedObject();
        this.calculateResultAmount(this.newStrategy);
        this.defaultStrategyId = response.id;
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : 'Failed to create Custom Rate';
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
    } else if (!this.newCustomRate.name) {
      this.toastService.pop(TOAST_TYPE.error, 'Please enter name');
    } else if (!this.newCustomRate.rate) {
      this.toastService.pop(TOAST_TYPE.error, 'Please enter rate');
    }
  }

  removeStrategy() {
    let obj = _.find(this.strategies, {selected: true});
    if (obj) {
      if(obj.reviewed) {
        _.remove(this.reviewedStrategiesData, {'strategyId': obj.id});
      }
      _.remove(this.strategies, {'id': obj.id});
      this.onStrategyRemoved.emit({list: this.strategies});
    }

    if (this.strategies && this.strategies.length > 0) {
      this.selectStrategy(this.strategies[0]);
    }
  }

  addToPlan() {
    if (this.reviewAndAddToPlan) {
      let obj = _.find(this.strategies, {selected: true});
      if (obj) {
        this.newStrategy['strategyId'] = obj.id;
        const { strategyId, clientId, sinceYear, toYear, associatedWith } = this.newStrategy;
        const yearRegex = /^\d{4}$/;
        
       if (!strategyId){
          this.showField = false;
          this.reviewAndAddToPlan = false;
          this.toastService.pop(TOAST_TYPE.error, 'Please select Tax strategy');
          setTimeout(() => {
            this.showField = true;
          });
        } else if (!clientId){
          this.showField = false;
          this.reviewAndAddToPlan = false;
          this.toastService.pop(TOAST_TYPE.error, 'Please select Related Party');
          setTimeout(() => {
            this.showField = true;
          });
        } else if (!sinceYear){
          this.showField = false;
          this.reviewAndAddToPlan = false;
          this.toastService.pop(TOAST_TYPE.error, 'Please select Start Year');
          setTimeout(() => {
            this.showField = true;
          });
        } else if (!yearRegex.test(sinceYear)) {
          this.showField = false;
          this.reviewAndAddToPlan = false;
          this.toastService.pop(TOAST_TYPE.error, 'Please enter Start Year in YYYY format');
          setTimeout(() => {
            this.showField = true;
          });
        } else if (toYear && !yearRegex.test(toYear)) {
          this.showField = false;
          this.reviewAndAddToPlan = false;
          this.toastService.pop(TOAST_TYPE.error, 'Please enter End Year in YYYY format');
          setTimeout(() => {
            this.showField = true;
          });
        }else if (toYear && parseInt(toYear) < parseInt(sinceYear)) {
            this.showField = false;
            this.reviewAndAddToPlan = false;
            this.toastService.pop(TOAST_TYPE.error, 'End Year cannot be earlier than Start Year');
            setTimeout(() => {
              this.showField = true;
            });
        } else if (!associatedWith){
          this.showField = false;
          this.reviewAndAddToPlan = false;
          this.toastService.pop(TOAST_TYPE.error, 'Please select Federal Associated Rate');
          setTimeout(() => {
            this.showField = true;
          });
        }else{
          const existingIdx = _.findIndex(this.reviewedStrategiesData, {strategyId: this.newStrategy.strategyId});
          this.newStrategy.investedAmount = this.newStrategy.investedAmount;
          if (existingIdx >= 0) {
            this.reviewedStrategiesData[existingIdx] = this.newStrategy;
          } else {
            this.reviewedStrategiesData.push(this.newStrategy);
          }
          _.each(this.strategies, (strategy) => {
            if (strategy.selected) {
              strategy.reviewed = true;
            }
          });
          this.onStrategyRiviewedSuccess.emit({ list: this.reviewedStrategiesData });
        }
      }
    } else {
      _.each(this.strategies, (strategy) => {
        if(strategy.selected) {
          strategy.reviewed = false;
          _.remove(this.reviewedStrategiesData, {'strategyId': strategy.id});
        }
      });
      this.onStrategyRiviewedSuccess.emit({list: this.reviewedStrategiesData});
    }
  }

  fillYears(){
    let startYear: any;
    if (this.plan && this.plan.beginYear) {
      startYear = _.toNumber(this.plan.beginYear);
    } else {
      startYear = _.toNumber(new Date().getFullYear());
    }
    const endYear: any = startYear + 10;
    for (let i = startYear; i < endYear; i++){
      this.years.push({id: i, name: i.toString()});
    }
  }

  parseCustomRates(){
    _.each(this.plan.customTaxRates, function(customTaxRate){
      try{
        // Skip if formula is already an object
        if (typeof customTaxRate.formula === 'object') {
          return;
        }
        
        // Handle common edge cases
        if (!customTaxRate.formula || customTaxRate.formula === 'undefined' || customTaxRate.formula === 'null') {
          customTaxRate.formula = {};
          return;
        }
        
        // Try to parse as JSON
        customTaxRate.formula = JSON.parse(customTaxRate.formula);
      } catch (e){
        console.error('Failed to parse formula for custom rate:', customTaxRate.name, 'Formula value:', customTaxRate.formula, 'Error:', e);
        // Set to empty object as fallback
        customTaxRate.formula = {};
      }
    });
  }

  appendCustomRates(){
    const base = this;
    _.each(this.plan.customTaxRates, function(customRate){
      const associated = _.find(base.associatedWith, {id: customRate.id});
      if (associated){
        associated.rate = customRate.rate;
      } else {
        if (customRate.formula && !customRate.formula.type) {
          base.associatedWith.push(customRate);
        } else if (!customRate.formula) {
          base.associatedWith.push(customRate);
        }
      }
    });
    this.associatedWith = [...this.associatedWith];
    this.buildAssociatedObject();
  }

  buildAssociatedObject(){
    const base = this;
    this.associatedWith = [...this.associatedWith];
    _.each(this.allTaxStrategies, function(obj){
      let strategyRates = [...base.associatedWith];
      if (obj.customTaxRates){
        _.each(obj.customTaxRates, (customTaxRate) => {
          if (typeof customTaxRate.formula === 'string') {
            try {
              customTaxRate.formula = JSON.parse(customTaxRate.formula);
            } catch (e) {
              console.error('Failed to parse formula : ', e);
            }
          }
        });
        strategyRates = strategyRates.concat(obj.customTaxRates);
      }
      base.allAssociatedData[obj.id] = strategyRates;
    });
  }

  buildStateAssociatedObject() {
    const data: any[] = [];
    const seenIds = new Set<string>();

    // RAP edit: state rate options may be preserved here (removed from customTaxRates to avoid duplication in Custom Rates form)
    if (this.plan && this.plan.stateRateDropdownOptions && this.plan.stateRateDropdownOptions.length > 0) {
      this.plan.stateRateDropdownOptions.forEach((opt: any) => {
        if (!seenIds.has(opt.id)) {
          data.push(opt);
          seenIds.add(opt.id);
        }
      });
    }

    // Include ALL custom rates (plan-level) in State Associated dropdown so newly added custom rates
    // are selectable for state calculations, not just those with formula.type markers.
    if (this.plan && this.plan.customTaxRates && this.plan.customTaxRates.length > 0) {
      this.plan.customTaxRates.forEach((customRate: any) => {
        const parsedFormula = typeof customRate.formula === 'string'
          ? (() => { try { return JSON.parse(customRate.formula); } catch (_) { return customRate.formula; } })()
          : customRate.formula;

        const rateEntry = { ...customRate, formula: parsedFormula };

        if (!seenIds.has(rateEntry.id)) {
          data.push(rateEntry);
          seenIds.add(rateEntry.id);
        }
      });
    }

    const naId = '454ba189-8222-11ef-bd9d-12ff30f54e53';
    if (!seenIds.has(naId)) {
      data.push({ id: naId, name: 'N/A' });
    }

    this.allStateAssociatedData = data;
  }

  /** Convert yyyy-MM-dd to MM/DD/YYYY to match backend DateUtils.getSQLDateFromString expectation. */
  private toDisplayDate(date: string): string {
    if (!date) return '';
    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      const [y, m, d] = date.split('-');
      return `${m}/${d}/${y}`;
    }
    return date;
  }

  createTaskForReviewField(fieldName, value, type?) {
    const task = {
      title: (type && type === 'goal date') ? 'Implement ' + this.currentSelectedStrategy.name : 'Review ' + fieldName + " for " + this.currentSelectedStrategy.name,
      type: (type) ? type : '',
      value: value,
      dueDate: '',
      description: 'Review ' + fieldName
    };

    if (type && type === 'goal date') {
      task.dueDate = this.toDisplayDate(value);
      task['strategyId'] = this.newStrategy.strategyId;
    } else {
      task.dueDate = this.toDisplayDate(this.newStrategy.goalDate || '');
    }
    this.onCreateTaskAction.emit(task);
  }

  updateGoalDate($event, strategy){
    strategy.goalDate = $event;
    if (strategy.goalDate) {
      this.createTaskForReviewField('Task Date', strategy.goalDate, 'goal date');
    }
  }

  scrollToBottom(): void {
    this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
  }

  toggleDescription(item) {
    item.showFullDescription = !item.showFullDescription;
  }

  getTooltipContent(label: string, info?: string): string {
    let content = `<div>${label}</div>`;
    if (info) {
      content += `<div>${info}</div>`;
    }
    return content;
  }


  calculateInvestmentAmount(strategy) {
    updateInvestmentOverride(
      strategy,
      this.parseInvestmentFormula(strategy.investmentFormula, Number(strategy.amount || 0)),
      Number(strategy.investedAmount || 0)
    );
    if (
      strategy?.investmentEnabled &&
      strategy?.investmentFormula &&
      strategy?.investedAmount
    ) {
      const calculatedValue = this.parseInvestmentFormula(
        strategy.investmentFormula,
        strategy.investedAmount
      );

      strategy.amount = calculatedValue;

      this.calculateResultAmount(strategy, true);
    }
  }

  parseInvestmentFormula(formula: any, amount: number): number {
    if (!formula || !amount) return 0;

    let value = formula.toString().trim();

    let multiplier = 0;

    // % case → 10%
    if (value.includes('%')) {
      multiplier = Number(value.replace('%', '')) / 100;
    }

    // division case → 10/100
    else if (value.includes('/')) {
      try {
        multiplier = evaluate(value);
      } catch {
        multiplier = 0;
      }
    }
    // decimal → 0.10
    else {
      const num = Number(value);
      multiplier = !isNaN(num) ? num : 0;
    }
    return amount * multiplier;
  }

  stripHtml(html: string): string {
    if (!html) return '';
    return html.replace(/<[^>]*>/g, '');
  }

  private normalizeStrategyFields(strategy: any): void {
    // investmentDescription — top-level suggestion field
    if (!strategy.investmentDescription) {
      strategy.investmentDescription =
        strategy.investment_description ?? '';
    }

    // planAmount — suggestion sends plan_amount (snake_case)
    if (strategy.planAmount == null && strategy.plan_amount != null) {
      strategy.planAmount = strategy.plan_amount;
    }

    // federal / state rate names
    if (!strategy.federalAssociatedRate) {
      strategy.federalAssociatedRate = strategy.federal_associated_rate ?? '';
    }
    if (!strategy.stateAssociatedRate) {
      strategy.stateAssociatedRate = strategy.state_associated_rate ?? '';
    }

    // field descriptor (used by plan amount tooltip)
    if (!strategy.fieldDescriptor) {
      strategy.fieldDescriptor = strategy.field_descriptor ?? '';
    }
  }

  private buildInvestmentDescription(strategy: any): string {
    const inv = strategy?.investment?.[0] ?? {};

    const incoming = this.getStrategyInvestmentDescription(strategy);

    if (incoming) return incoming;

    // Fallback — covers both camelCase and snake_case plan amount
    const planAmount: number =
      strategy?.planAmount ??
      strategy?.plan_amount ??
      strategy?.amount ??
      0;

    const invFormula: string =
      inv?.investment_formula ||
      strategy?.investmentFormula ||
      strategy?.investment_formula ||
      inv?.investmentFormula ||
      '1';

    return `Investment amount will be $${planAmount} / ${invFormula}, Invest 20% of $${planAmount.toLocaleString()} to generate ${invFormula} X deduction`;
  }

  private getStrategyInvestmentDescription(strategy: any): string {
    const inv = strategy?.investment?.[0] ?? {};

    return (
      (strategy?.investmentDescription ?? '').trim() ||
      (strategy?.investment_description ?? '').trim() ||
      (inv?.investmentDescription ?? '').trim() ||
      (inv?.investment_description ?? '').trim() ||
      ''
    );
  }

}
